import { useCallback, useRef, useState } from "react";

const useAsyncSubmit = () => {
    const inFlightRef = useRef(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const run = useCallback(async (callback) => {
        if (inFlightRef.current) {
            return null;
        }

        inFlightRef.current = true;
        setIsSubmitting(true);

        try {
            return await callback();
        } finally {
            inFlightRef.current = false;
            setIsSubmitting(false);
        }
    }, []);

    return { isSubmitting, run };
};

export default useAsyncSubmit;
